var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThunderBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_237",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232",
    transform: "translate(-972.93 -458.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 972.93, 458.51)",
    filter: "url(#Rectangle_237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_237-2",
    "data-name": "Rectangle 237",
    transform: "translate(3 2)",
    fill: "#596af8",
    stroke: "#3b50fa",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_728951_electricity_lightning_charge_electric_forecast_icon",
    "data-name": "728951_electricity_lightning_charge_electric_forecast_icon",
    d: "M26.364,4.125H25.008l1.886-3.056a.735.735,0,0,0,.032-.706A.632.632,0,0,0,26.364,0H23.183a.629.629,0,0,0-.552.346L20.085,5.159a.735.735,0,0,0,0,.686.628.628,0,0,0,.55.342h2.085l-2,3.784a.725.725,0,0,0,.166.888.6.6,0,0,0,.386.141.611.611,0,0,0,.45-.2l5.091-5.5a.728.728,0,0,0,.138-.749A.639.639,0,0,0,26.364,4.125Z",
    transform: "translate(962.43 465.01)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThunderBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thunderBlue.a558a5ec.svg";
export { ForwardRef as ReactComponent };